import React, { createContext, useContext, useState, useEffect } from "react";
import UserServiceService from "../Services/userServiceService";

const UserServicesContext = createContext();

export const UserServicesProvider = ({ children }) => {
  const [userServicesData, setUserServicesData] = useState([]);
  const [isFetchingUserServices, setIsFetchingUserServices] = useState(true);

  useEffect(() => {
    fetchUserServices();
  }, []);

  const fetchUserServices = async () => {
    setIsFetchingUserServices(true);
    try {
      const fetchUserServicesData = await UserServiceService.GetUserServiceList();
      setUserServicesData(fetchUserServicesData);
    } catch (error) {
      console.error("Erreur lors du chargement des services", error);
    } finally {
      setIsFetchingUserServices(false);
    }
  };

  const updateUserService = async (id) => {
    const fetchUserServiceCard = await UserServiceService.GetUserService(id);
    setUserServicesData(
      userServicesData.map((userService) =>
        userService.externalId === fetchUserServiceCard.externalId
          ? { ...userService, ...fetchUserServiceCard }
          : userService,
      ),
    );
  };

  return (
    <UserServicesContext.Provider
      value={{ userServicesData, fetchUserServices, updateUserService, isFetchingUserServices }}>
      {children}
    </UserServicesContext.Provider>
  );
};

export const useUserServices = () => useContext(UserServicesContext);
